import { useState, useRef } from 'react';
import MediaItem from 'src/components/MediaGallery/MediaItem';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Download } from 'react-bootstrap-icons';
import { Close } from '@mui/icons-material';

import MediaDownloadButton from 'src/components/button/MediaDownloadButton';

const MediaCarousel = ({ media = [], onClose, initIndex = 0 }) => {
  const [currentMediaIndex, setCurrentMediaIndex] = useState(initIndex);

  const handleNext = () => {
    setCurrentMediaIndex((prevIndex) => (prevIndex + 1) % media.length);
  };

  const handlePrev = () => {
    setCurrentMediaIndex((prevIndex) => (prevIndex - 1 + media.length) % media.length);
  };

  const backgroundRef = useRef();

  const handleBackgroundClick = (event) => {
    if (event.target === backgroundRef.current) {
      onClose();
    }
  };

  return (
    <div
      ref={backgroundRef}
      onClick={handleBackgroundClick}
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        zIndex: 90,
      }}
      className="flex flex-col gap-10 items-center justify-center fixed top-0 left-0 h-screen w-screen"
    >
      <div className="md:w-[75%] w-[85%] md:h-[75%] h-[85%] relative">
        <button
          className="absolute top-3 right-3 p-2 rounded-full bg-gray-700 bg-opacity-60 hover:bg-opacity-80 transition ease-in-out duration-200 focus:outline-none z-10"
          onClick={onClose}
          aria-label="Close"
        >
          <Close className="text-white" />
        </button>

        <MediaItem
          key={currentMediaIndex}
          src={media[currentMediaIndex].src}
          type={media[currentMediaIndex].type}
          thumbnail={media[currentMediaIndex].thumbnail}
          caption={media[currentMediaIndex].caption}
          fullDisplay={true}
        />
        <button
          className="absolute top-1/2 transform -translate-y-1/2 right-0 mr-[-25px] sm:mr-[-50px] bg-gray-500 w-10 h-10 rounded-full text-2xl border-2 text-white flex items-center justify-center hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          onClick={handleNext}
        >
          <ChevronRightIcon />
        </button>
        <button
          className="absolute top-1/2 transform -translate-y-1/2 left-0 ml-[-25px] sm:ml-[-50px] bg-gray-500 w-10 h-10 rounded-full text-2xl p-2 border-2 text-white flex items-center justify-center hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          onClick={handlePrev}
        >
          <ChevronLeftIcon />
        </button>
      </div>

      <MediaDownloadButton
        attachmentUrl={media[currentMediaIndex].attachmentUrl}
        originalFileName={media[currentMediaIndex].originalFileName}
        Icon={() => <Download />}
        customStyles={{
          color: 'white',
        }}
      />
    </div>
  );
};

export default MediaCarousel;
